
























































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, Mutation } from "vuex-class";

import AppLogo from "@/components/ui/AppLogo.vue";
import AppTopNavbarBanner from "@/components/ui/AppTopNavbarBanner.vue";
import I18nLocaleSelect from "@/components/ui/I18nLocaleSelect.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * App top navigation bar with static content
 */
@Component({
  components: { I18nLocaleSelect, AppTopNavbarBanner, AppLogo },
  filters: {
    ...capitalizeFilter
  }
})
export default class AppTopNavbar extends Vue {
  @Action("auth/logout") logout!: () => void;
  @Mutation("ui/toggleTopNavbar") toggleTopNavbar!: () => void;
  @Mutation("ui/toggleTopNavbarBanner") toggleTopNavbarBanner!: () => void;

  /** Returns Material Icons icon name for current navbar banner state */
  get navbarBannerToggleBtnIconName(): string {
    const direction = this.$store.state.ui.topNavbarBannerOpened
      ? "upward"
      : "downward";
    return `arrow_${direction}`;
  }

  /** Returns Material Icons icon name for current navbar state */
  get navbarToggleBtnIconName(): string {
    return this.$store.state.ui.topNavbarOpened ? "close" : "menu_open";
  }

  /** Returns navbar items element class name for current navbar state */
  get navbarNavClassName(): object {
    const isOpened = this.$store.state.ui.topNavbarOpened;
    return {
      "navbar__nav--mobile-shown": isOpened,
      "navbar__nav--mobile-hidden": !isOpened
    };
  }

  /** Returns legacy app URL */
  get legacyAppUrl(): string | undefined {
    return process.env.VUE_APP_LEGACY_APP_URL;
  }

  i18nMessageKeyEnum = I18nMessageKey;

  getLegacyAppUrl(url: string): string {
    return process.env.VUE_APP_LEGACY_APP_URL + "/" + url;
  }
}
